import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="activity-form"
export default class extends Controller {
  static targets = ["saveButton"]

  connect() {
    console.log("Activity form controller connected")
  }

  save(event) {
    event.preventDefault()

    console.log("🔵 Save button clicked!")
    console.log("🔵 Form element:", this.element)

    const activityCard = this.element.closest('[data-activity-card]')
    console.log("🔵 Activity card:", activityCard)
    console.log("🔵 Activity ID:", activityCard?.dataset.activityId)
    console.log("🔵 All card dataset:", activityCard?.dataset)

    const activityId = activityCard?.dataset.activityId

    // Get form data from the configuration tab
    const formData = this.collectFormData()

    // Show loading state
    this.setLoadingState(true)

    if (!activityId) {
      // No ID = new activity, create it
      console.log("📝 Creating new activity:", formData)
      this.createNewActivity(formData, activityCard)
    } else {
      // Has ID = existing activity, update it
      console.log("💾 Updating activity:", activityId, formData)
      this.updateActivity(activityId, formData)
    }
  }

  collectFormData() {
    const formData = {}
    const configForm = this.element

    // Get all inputs, textareas, and selects
    const inputs = configForm.querySelectorAll('input, textarea, select')

    inputs.forEach(input => {
      const name = input.name
      if (name) {
        // Extract field name from activity[field_name] format
        const fieldMatch = name.match(/activity\[(.+)\]/)
        const fieldName = fieldMatch ? fieldMatch[1] : name

        if (input.type === 'checkbox') {
          formData[fieldName] = input.checked
        } else if (input.type === 'file') {
          // Handle file inputs separately
          if (input.files && input.files.length > 0) {
            formData[fieldName] = input.files
          }
        } else if (input.value) {
          formData[fieldName] = input.value
        }
      }
    })

    // Collect selected activities from file-upload controller (activity chips)
    const activityChips = configForm.querySelectorAll('[data-activity-chip]')
    const selectedActivityIds = []
    activityChips.forEach(chip => {
      const activityId = chip.dataset.activityId
      if (activityId) {
        selectedActivityIds.push(activityId)
      }
    })

    // Collect personas from tag input
    const personaTags = configForm.querySelectorAll('[data-tag-input-target="input"]')
    const personas = []
    personaTags.forEach(input => {
      // Get existing tags from the container
      const tagContainer = input.closest('.flex')
      if (tagContainer) {
        const tags = tagContainer.querySelectorAll('[data-ui-tag]')
        tags.forEach(tag => {
          const text = tag.textContent.trim()
          if (text && !personas.includes(text)) {
            personas.push(text)
          }
        })
      }
    })

    // Map frontend field names to backend field names
    const mapped = {
      title: formData.name || formData.title || 'Untitled Activity',
      objective: formData.description || formData.objective,
      duration_minutes: formData.duration ? parseInt(formData.duration) : 60,
      scheduled_start_on: formData.timeline,
      welcome_message: formData.welcome_message || '',
      metadata: {
        configuration: {
          duration: formData.duration || '60',
          description: formData.description || '',
          personas: personas,
          input_activity_ids: selectedActivityIds
        }
      }
    }

    return mapped
  }

  async createNewActivity(formData, activityCard) {
    try {
      // Get phase ID from the parent phase (for multiple inloop)
      const phaseElement = activityCard.closest('[data-phase-id]')
      const phaseId = phaseElement?.dataset.phaseId

      // Prepare activity data
      const activityData = {
        ...formData,
        status: 'not_started'
      }

      // Only add phase_id if it exists (multiple inloop)
      // For single inloop, phase_id is optional
      if (phaseId) {
        activityData.activity_phase_id = phaseId
      }

      console.log("Creating activity with data:", activityData)

      const response = await fetch('/activities', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCsrfToken()
        },
        body: JSON.stringify({
          activity: activityData
        })
      })

      if (response.ok) {
        const data = await response.json()
        this.showSuccess("Activity created successfully")
        console.log("Create response:", data)

        // Update card with new activity ID
        if (data.activity && data.activity.id) {
          activityCard.dataset.activityId = data.activity.id
        }

        // Optionally reload page to show updated activity
        // window.location.reload()
      } else {
        const error = await response.json()
        this.showError(error.message || "Failed to create activity")
      }
    } catch (error) {
      console.error("Create error:", error)
      this.showError("Network error: Could not create activity")
    } finally {
      this.setLoadingState(false)
    }
  }

  async updateActivity(activityId, formData) {
    try {
      const response = await fetch(`/activities/${activityId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCsrfToken()
        },
        body: JSON.stringify({ activity: formData })
      })

      if (response.ok) {
        const data = await response.json()
        this.showSuccess("Activity updated successfully")
        console.log("Update response:", data)
      } else {
        const error = await response.json()
        this.showError(error.message || "Failed to update activity")
      }
    } catch (error) {
      console.error("Update error:", error)
      this.showError("Network error: Could not update activity")
    } finally {
      this.setLoadingState(false)
    }
  }

  setLoadingState(loading) {
    if (this.hasSaveButtonTarget) {
      this.saveButtonTarget.disabled = loading
      this.saveButtonTarget.textContent = loading ? "Saving..." : "Save"
    }
  }

  showSuccess(message) {
    // You can integrate with your toast/notification system here
    console.log("Success:", message)
    // TODO: Add visual feedback (toast notification, etc.)
  }

  showError(message) {
    // You can integrate with your toast/notification system here
    console.error("Error:", message)
    alert(message) // Temporary - replace with better UI
  }

  getCsrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.content : ''
  }
}
